<template>
  <div class="wishlist-page">
    <h1 class="page-title">💚 Ma liste de souhaits</h1>

    <div v-if="loading" class="loading">Chargement...</div>
    <div v-else-if="wishlist.length === 0" class="empty">
      <p>Votre liste de souhaits est vide.</p>
      
    </div>

    <div v-else class="wishlist-grid">
      <div v-for="(item, index) in wishlist" :key="index" class="wishlist-item">
        <img :src="item.image" :alt="item.name" class="item-image" />
        <div class="item-info">
          <h3>{{ item.name }}</h3>
          <p class="price">{{ item.price }} MAD</p>
        </div>

        <div class="item-actions">
          <button @click="addToCart(item)" class="btn add-cart">🛒 Ajouter au panier</button>
          <button @click="removeFromWishlist(item)" class="btn delete">🗑 Supprimer</button>
        </div>
      </div>
      
    </div>
    <div class="page-title">
    <button @click="$router.push('/shop')" class="btn primary">Voir les produits</button>
    </div>
    <div v-if="message" class="alert">{{ message }}</div>

  </div>
</template>

<script>
import axios from "axios";
import { store } from "@/Store"; // ton store panier global

export default {
  name: "WishList",
  data() {
    return {
      wishlist: [],
      loading: true,
      message: "",
    };
  },
  async mounted() {
    await this.fetchWishlist();
  },
  methods: {
    async fetchWishlist() {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          this.$router.push("/connexion");
          return;
        }
        const res = await axios.get("http://localhost:2028/api/wishlist", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.wishlist = res.data;
      } catch (err) {
        console.error("Erreur de chargement wishlist :", err);
        this.message = "Impossible de charger la wishlist.";
      } finally {
        this.loading = false;
      }
    },

    async removeFromWishlist(item) {
      try {
        const token = sessionStorage.getItem("token");
        await axios.delete(`http://localhost:2028/api/wishlist/${item.productId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.wishlist = this.wishlist.filter((p) => p.productId !== item.productId);
        this.message = "Produit supprimé de la wishlist.";
      } catch (err) {
        console.error("Erreur suppression wishlist :", err);
        this.message = "Erreur lors de la suppression.";
      }
    },

    addToCart(item) {
      store.addToCart(item);
      this.message = `${item.name} ajouté au panier 🛒`;
      setTimeout(() => (this.message = ""), 2000);
    },
  },
};
</script>

<style scoped>
.wishlist-page {
  padding: 30px;
  background: #f9f9f9;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
}
.page-title {
  font-size: 26px;
  font-weight: 700;
  color: #00998b;
  text-align: center;
  margin-bottom: 30px;
}

.loading {
  text-align: center;
  color: #555;
}

.empty {
  text-align: center;
  color: #444;
}

.wishlist-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  height: 100%;
  
}

.wishlist-item {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.25s;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wishlist-item:hover {
  transform: translateY(-4px);
}
.item-image {
  width: 100%; height: 100%;
  object-fit: cover; border-radius: 12px;
  background: #fafafa;
}
.item-info {
  text-align: center;
  margin: 10px 0;
}
.price {
  color: #00796b;
  font-weight: 600;
}

.item-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 10px;
}

.btn {
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  border: none;
  transition: background 0.3s;
}
.btn.primary {
  background: #00998b;
  color: #fff;
}
.btn.add-cart {
  background: #00bfa5;
  color: #fff;
}
.btn.delete {
  background: #e53935;
  color: #fff;
}
.btn:hover {
  opacity: 0.85;
}

.alert {
  text-align: center;
  margin-top: 15px;
  color: #00998b;
  font-weight: 500;
}

/* Mode sombre */
@media (prefers-color-scheme: dark) {
  .wishlist-page {
    background: #0f141b;
    color: #e6edf1;
  }
  .wishlist-item {
    background: #1a1f29;
    color: #e6edf1;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);
  }
  .btn.add-cart {
    background: #00bfa5;
  }
  .btn.delete {
    background: #c62828;
  }

  .item-image {
  width: 50%; height: 50%;
  object-fit: cover; border-radius: 12px;
  background: #333333;
}
}
</style>
